import { useEffect, useState, Fragment } from "react";
import {
    Pressable,
    StyleSheet,
} from "react-native";

import { useNavigate } from 'react-router-dom';

import { SideBarItemData, SideBarSubItemData } from "./sideBarData";
import SideBarCollapsedMenuSubItem from "./sideBarCollapsedMenuSubItem";
import { PAGE_URL } from "../../../value/Url";

interface SideBarCollapsedMenuItemProps {
    key: number,
    item: Readonly<SideBarItemData>,
    menuItemHoverCb: Function,
    menuItemActiveCb: Function,
    hoverItemIdForOpenSubItem: number,
    activeItemId: number,
}

export default function SideBarCollapsedMenuItem(props:SideBarCollapsedMenuItemProps) {
    const [menuItemContainerStyle, setMenuItemContainerStyle] = useState(style.menuBar);
    const [menuItemMouseActiveYn, setMenuItemMouseActiveYn] = useState(false);
    const [menuItemMouseHoverYn, setMenuItemMouseHoverYn] = useState(false);
    
    const inactiveContainerBackgroundColor = "#212943";
    const activeContainerBackgroundColor = "#323ba6";
    const hoverContainerBackgroundColor = "#1a1f33";

    const navigate = useNavigate();

    useEffect(() => {
        if(props.item.sub.length === 0) {
            if(!setCurrentPath(props.item.path)) {
                setCurrentPath(props.item.path + '/' + PAGE_URL.DETAIL_MANAGEMENT);
            }
        } else {
            for(let i = 0; i < props.item.sub.length; i++) {
                if(setCurrentPath(props.item.sub[i].path)) {
                    break;
                }
                if(setCurrentPath(props.item.sub[i].path + '/' + PAGE_URL.DETAIL_MANAGEMENT)) {
                    break;
                }
            }
        }
    });

    useEffect(() => {
        if(menuItemMouseHoverYn) {
            setMenuItemContainerStyle({...style.menuBar, backgroundColor: hoverContainerBackgroundColor});
            props.menuItemHoverCb(props.item.id);
        } else {
            if(menuItemMouseActiveYn) {
                setMenuItemContainerStyle({...style.menuBar, backgroundColor: activeContainerBackgroundColor});
            } else {
                setMenuItemContainerStyle({...style.menuBar, backgroundColor: inactiveContainerBackgroundColor});
            }
        }
    }, [menuItemMouseHoverYn]);

    useEffect(() => {
        if(menuItemMouseActiveYn) {
            setMenuItemContainerStyle({...style.menuBar, backgroundColor: activeContainerBackgroundColor});
            props.menuItemActiveCb(props.item.id);
        } else {
            setMenuItemContainerStyle({...style.menuBar, backgroundColor: inactiveContainerBackgroundColor});
        }
    }, [menuItemMouseActiveYn]);


    function setCurrentPath(itemPath) {
        const path = window.location.pathname;
        if(path === itemPath) {
            setMenuItemMouseActiveYn(true);
            props.menuItemActiveCb(props.item.id);
            return true;
        } else {
            setMenuItemMouseActiveYn(false);
            return false;
        }
    }

    function informHoverOut() {
        props.menuItemHoverCb(0);
    }

    function clickMenuLink(linkTarget) {
        if(props.item.sub.length === 0) {
            navigate(linkTarget);
            setMenuItemMouseActiveYn(true);
        }
    }

    return (
        <Fragment>
            <div style={{
                zIndex: "unset",
                border: "solid 0.5px #32384d"
            }}>
                <Pressable
                    style={menuItemContainerStyle}
                    onPress={()=>clickMenuLink(props.item.path)}
                    onHoverOut={()=>setMenuItemMouseHoverYn(false)}
                    onHoverIn={()=>setMenuItemMouseHoverYn(true)}
                >
                    {
                        menuItemMouseActiveYn ? props.item.activeImgComponent : props.item.imgComponent
                    }
                </Pressable>
                {
                    props.item.sub.length > 0 && props.item.id === props.hoverItemIdForOpenSubItem?
                    <Pressable
                        style={{position:"absolute", marginTop:-50, marginLeft:70, backgroundColor:"#212943", zIndex:9, shadowColor:"rgba(0,0,0,0.2)", shadowRadius:10, paddingTop:10, paddingBottom:10}}
                        onHoverOut={()=>informHoverOut()}>
                        {
                            props.item.sub.map((sub:SideBarSubItemData, index) => {
                                return (
                                    <SideBarCollapsedMenuSubItem key={index} item={sub}/>
                                )
                            })
                        }
                    </Pressable>
                    : null
                }
            </div>
        </Fragment>
    );
}

const style = StyleSheet.create({
    menuBar:{
        height: 50,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#212943"
    }
})